import React, { useState, useEffect } from 'react';
import styles from './Register.module.css';
import { useAuth } from '../Context/Auth';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
  });

  const { registerUser, loading, error, success, isLoggedIn, clearMessages } = useAuth();
  const navigate = useNavigate();

  // Clear old messages
  useEffect(() => clearMessages(), [clearMessages]);

  // Already logged in notice
  useEffect(() => {
    if (isLoggedIn) {
      toast('You are already logged in!', {
        icon: 'ℹ️',
        style: { fontSize: '17px', background: '#007bff', color: '#fff', fontWeight: 'bold' },
      });
    }
  }, [isLoggedIn]);

  // Success or error toast
  useEffect(() => {
    if (success) {
      toast.success(success, {
        style: { fontSize: '18px', background: '#28a745', color: '#fff', fontWeight: 'bold' },
      });
      setTimeout(() => navigate('/login'), 1500);
    }
    if (error) {
      toast.error(error, {
        style: { fontSize: '18px', background: '#dc3545', color: '#fff', fontWeight: 'bold' },
      });
    }
  }, [success, error, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check password match
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!", {
        style: { fontSize: '17px', background: '#ff4d4d', color: '#fff', fontWeight: 'bold' },
      });
      return;
    }

    // Validate password length
    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters long!", {
        style: { fontSize: '17px', background: '#ff4d4d', color: '#fff', fontWeight: 'bold' },
      });
      return;
    }

    // Validate phone number
    if (formData.phoneNumber.length < 10) {
      toast.error("Phone number must be at least 10 digits!", {
        style: { fontSize: '17px', background: '#ff4d4d', color: '#fff', fontWeight: 'bold' },
      });
      return;
    }

    await registerUser(formData);
  };

  return (
    <div className={styles.registerContainer}>
      <div className={styles.registerBox}>
        <h2 className={styles.title}>Register</h2>
        <form onSubmit={handleSubmit} className={styles.form}>
          {['fullName', 'email', 'phoneNumber', 'password', 'confirmPassword'].map((field) => (
            <div key={field} className={styles.inputGroup}>
              <label htmlFor={field} className={styles.label}>
                {field === 'fullName' ? 'Full Name' : field === 'confirmPassword' ? 'Confirm Password' : field.charAt(0).toUpperCase() + field.slice(1)}
              </label>
              <input
                type={field.includes('password') ? 'password' : field === 'email' ? 'email' : 'text'}
                id={field}
                name={field}
                className={styles.inputField}
                placeholder={field === 'fullName' ? 'Full Name' : field === 'email' ? 'example@email.com' : field === 'phoneNumber' ? '01234567890' : 'Minimum 6 characters'}
                value={formData[field]}
                onChange={handleChange}
                required
                minLength={field.includes('password') ? 6 : field === 'fullName' ? 3 : 0}
                maxLength={field === 'phoneNumber' ? 15 : undefined}
                disabled={loading}
              />
            </div>
          ))}
          <button type="submit" className={styles.registerButton} disabled={loading}>
            {loading ? "Registering..." : "REGISTER"}
          </button>
        </form>
        <p className={styles.loginPrompt}>
          Already have an account? <Link to="/login" className={styles.loginLink}>Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
